module.exports = __webpack_public_path__ + "d165736e46603c5cf167883e7c8110de.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BL.svg
// module id = Y7R/
// module chunks = 0